import { Backdrop, Box, CircularProgress, LinearProgress } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import portalSettingsManager from "utils/portalSettingsManager";

export const Loader = ({
  isDisplay = false,
  message,
  type = "page",
}: {
  isDisplay?: boolean;
  message?: string;
  type?: "page" | "component" | "linear";
}): React.ReactElement => {
  const theme = useTheme();
  const { t } = useTranslation();

  if (type === "component" && isDisplay) {
    return (
      <Backdrop
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width: "100% !important",
          zIndex: theme.zIndex.modal + 1,
          color: "white",
          "& > span": {
            padding: "6px",
          },
        }}
        open={isDisplay}
      >
        <CircularProgress
          sx={{
            background: "white",
            width: "12px",
            height: "12px",
            borderRadius: "50%",
            boxShadow: "1px 1px 1px grey",
            color:
              portalSettingsManager.application?.common?.themeColor || theme.palette.primary.main,
          }}
          size={30}
          thickness={6}
        />
        <Box style={{ color: theme.palette.common.black }}>{message}</Box>
      </Backdrop>
    );
  } else if (type === "page" && isDisplay) {
    return (
      <Backdrop
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width: "100% !important",
          zIndex: theme.zIndex.modal + 1,
          color: "white",
          "& > span": {
            padding: "6px",
          },
        }}
        open={isDisplay}
      >
        <CircularProgress
          sx={{
            background: "white",
            width: "12px",
            height: "12px",
            borderRadius: "50%",
            boxShadow: "1px 1px 1px grey",
            color:
              portalSettingsManager.application?.common?.themeColor || theme.palette.primary.main,
          }}
          size={30}
          thickness={6}
        />
        <div>{t("please_wait", "")}</div>
      </Backdrop>
    );
  } else if (type == "linear" && isDisplay) {
    return (
      <LinearProgress
        sx={{
          background:
            portalSettingsManager.application?.common?.themeColor || theme.palette.primary.main,
          "& .MuiLinearProgress-bar1Indeterminate": {
            background: grey[200],
          },
          "& .MuiLinearProgress-bar2Indeterminate": {
            background: grey[400],
          },
        }}
      />
    );
  } else {
    return <></>;
  }
};
